export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.spark_admin_dashboard_language;
  },
  // END:: GET APP LOCALE
};
